import { Link } from '@tanstack/react-router'
import { can } from '../access'
import { useAccess } from '../access-context'
import { useLocale } from '../i18n'

/**
 * S5c: a booking named in a report or a check against Stripe, by its code.
 * A link for whoever can open bookings; the code alone, never a dead link,
 * for a holder of reports.view who cannot. Money with no booking says so.
 */
export function BookingCode({ code }: { code: string | null }) {
  const { messages: m } = useLocale()
  const { access } = useAccess()
  if (code === null) return <span className="text-text-muted">{m.morningEmail.noBooking}</span>
  if (!can(access, 'bookings.read')) return <span className="figures font-bold">{code}</span>
  return (
    <Link to="/bookings/$code" params={{ code }} className="figures font-bold touch-target">
      {code}
    </Link>
  )
}
